import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

declare const gapi: any;
declare const google: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleDrivePickerService {

  private clientId = environment.google.clientId;
  private apiKey = environment.google.apiKey;
  // The Picker's setAppId() requires the Google Cloud project NUMBER (not project ID string).
  // This is the same as Firebase's messagingSenderId.
  private appId = environment.firebaseConfig.messagingSenderId;
  private scope = 'https://www.googleapis.com/auth/drive.file';
  // private scope =
  //   'https://www.googleapis.com/auth/drive \
  //   https://www.googleapis.com/auth/drive.file \
  //   https://www.googleapis.com/auth/drive.metadata \
  //   https://www.googleapis.com/auth/drive.metadata.readonly \
  //   https://www.googleapis.com/auth/drive.readonly';

  private tokenClient = null;
  private oauthAccessToken = null;
  private pickerApiLoaded = false;
  private pickerCallback = null;
  private pickerInited = false;
  private gisInited = false;
  private driveLoaded = false;

  public open(callback): void {
    this.pickerCallback = callback;
    gapi.load('client:picker');
    this.tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: this.clientId,
      scope: this.scope,
      immediate: true,

    });
    this.gisInited = true;
    this.onPickerApiLoad();
  }

  onPickerApiLoad() {
    this.pickerInited = true;
    this.createPicker();
  }

  private createPicker(): void {
    // // OPCIÓN 1: Usar la vista PDF nativa de Google Picker. Muestra miniaturas pero se rompen porque necesitaríamos un scope más amplio que preferimos no configurar (drive.readonly, acceso a leer todos los archivos del usuario)
    // const showPicker = () => {
    //   const view = new google.picker.View(google.picker.ViewId.PDFS);
    //   const picker = new google.picker.PickerBuilder()
    //     .enableFeature(google.picker.Feature.NAV_HIDDEN)
    //     .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
    //     .setAppId(this.appId)
    //     .setOAuthToken(this.oauthAccessToken)
    //     .addView(view)
    //     .addView(new google.picker.DocsUploadView())
    //     .setDeveloperKey(this.apiKey)
    //     .setCallback(this.pickerCallback)
    //     .build();
    //   picker.setVisible(true);
    // };

    // // OPCIÓN 2: Usar DocsView con modo LISTA para mostrar solo PDFs en formato lista. Pero no permite navegar por carpetas
    // const showPicker = () => {
    //   // 1. Usamos DocsView en lugar de View y le aplicamos el modo LISTA
    //   const view = new google.picker.DocsView(google.picker.ViewId.PDFS)
    //     .setMode(google.picker.DocsViewMode.LIST);

    //   const picker = new google.picker.PickerBuilder()
    //     .enableFeature(google.picker.Feature.NAV_HIDDEN)
    //     .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
    //     .setAppId(this.appId)
    //     .setOAuthToken(this.oauthAccessToken)
    //     .addView(view) // 2. Pasamos nuestra vista ya configurada
    //     .addView(new google.picker.DocsUploadView())
    //     .setDeveloperKey(this.apiKey)
    //     .setCallback(this.pickerCallback)
    //     .build();

    //   picker.setVisible(true);
    // };

    // OPCIÓN 3: Usar DocsView normal pero filtrando por MIME type para mostrar solo PDFs. Permite navegar por carpetas y no muestra miniaturas ni vista previa
    const showPicker = () => {
      const view = new google.picker.DocsView(google.picker.ViewId.DOCS)
        .setIncludeFolders(true) // activa la navegación por carpetas
        .setMimeTypes('application/pdf') // filtra para que solo se vean PDFs y carpetas
        .setMode(google.picker.DocsViewMode.LIST); // mantiene la vista limpia tipo lista, no miniaturas

      const picker = new google.picker.PickerBuilder()
        .enableFeature(google.picker.Feature.NAV_HIDDEN)
        .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
        .setAppId(this.appId)
        .setOAuthToken(this.oauthAccessToken)
        .addView(view)
        .addView(new google.picker.DocsUploadView())
        .setDeveloperKey(this.apiKey)
        .setCallback(this.pickerCallback)
        .build();

      picker.setVisible(true);
    };


    // Request an access token
    this.tokenClient.callback = async (response) => {
      if (response.error !== undefined) {
        throw (response);
      }
      this.oauthAccessToken = response.access_token;
      // Sync the token into gapi.client so the Picker
      // and any gapi.client calls have the correct auth context
      gapi.client.setToken({ access_token: response.access_token });
      showPicker();
    };
    if (this.oauthAccessToken === null) {
      // Prompt the user to select a Google Account and ask for consent to share their data
      // when establishing a new session.
      this.tokenClient.requestAccessToken({ prompt: 'consent' });
    } else {
      // Skip display of account chooser and consent dialog for an existing session.
      this.tokenClient.requestAccessToken({ prompt: '' });
    }
  }

  async getFiles(docs: any): Promise<File[]> {
    const prom = docs.map(doc => {
      return new Promise<File>((resolveFile, rejectFile) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', 'https://www.googleapis.com/drive/v3/files/' + doc.id + '?alt=media', true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + this.oauthAccessToken);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            const blob = xhr.response;
            resolveFile(new File([blob], doc.name, { type: doc.mimeType }));
          } else {
            console.error(`Error downloading file "${doc.name}" from Google Drive: HTTP ${xhr.status}`);
            rejectFile(new Error(`No se pudo descargar el archivo "${doc.name}" desde Google Drive (HTTP ${xhr.status}). Verifica los permisos de tu cuenta.`));
          }
        };
        xhr.onerror = () => {
          console.error(`Network error downloading file "${doc.name}" from Google Drive`);
          rejectFile(new Error(`Error de red al descargar "${doc.name}" desde Google Drive.`));
        };
        xhr.send();
      });
    });
    return Promise.all(prom);
  }
}
